// Vuetify 3용 테마 설정 (Vue 3 전환 단계에서 사용)
export const themePresetV3 = {
  rtl: false,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#1976D2',
          secondary: '#304156',
          success: '#4CAF50',
          danger: '#F44336',
          warning: '#FF5722',
          info: '#3F51B5',
          dark: '#111828',
          background: '#f2f2f2',
        },
      },
      dark: {
        colors: {
          primary: '#1976D2',
          secondary: '#304156',
          success: '#4CAF50',
          danger: '#F44336',
          warning: '#FF5722',
          info: '#3F51B5',
          background: '#333333',
        },
      },
    },
  },
}
